import './bootstrap';
import '../css/app.css';
import '@mantine/core/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-contextmenu/styles.layer.css';
import '../css/layout.css';

import { createInertiaApp } from '@inertiajs/react';
import * as Sentry from '@sentry/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';

import { environment } from '@/helpers.js';

Sentry.init({
  environment: environment(),
  dsn: 'https://bf3c43ac382f39b4da5f6a76bb987d69@o64741.ingest.us.sentry.io/4506903355588608',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/hisselitapu\.test/,
    /^https:\/\/test.hisselitapu\.com/,
    /^https:\/\/hisselitapu\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysSessionSampleRate: 1.0, // 100%
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const appName = window.document.getElementsByTagName('title')[0]?.innerText;

createInertiaApp({
  title: title => `${[title, appName].filter(Boolean).join(' - ')}`,
  resolve: name => resolvePageComponent(`./pages/${name}.jsx`, import.meta.glob('./pages/**/*.jsx')),
  setup({ el, App, props }) {
    const root = createRoot(el);

    root.render(<App {...props} />);
  },
  progress: {
    color: '#4B5563',
  },
}).then();
